/* unplugin-vue-components disabled */import __unplugin_components_0 from '/Users/Zhuanz/Desktop/project/oral-app/src/components/Tabbar.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = ["id"];
import * as echarts from 'echarts';
import { countStatApi, lineStatApi } from '@/api/stat';
import { showNotify } from 'vant';
export default /*@__PURE__*/_defineComponent({
  __name: 'Stat',
  setup(__props) {
    const show = ref(false);
    const active = ref(0);
    const statParam = ref({
      name: '',
      active: active.value,
      dateList: []
    });
    const lineModel = ref({
      legendData: [],
      xaxisData: [],
      series: []
    });
    const minDate = ref(new Date(1919, 1, 1));
    const pieData = ref([]);
    const formatDate = date => `${date.getMonth() + 1}/${date.getDate()}`;
    const onConfirm = values => {
      const [start, end] = values;
      show.value = false;
      tabs.value[active.value].name = `${formatDate(start)} - ${formatDate(end)}`;
      statParam.value.dateList = [start, end];
    };
    const tabs = ref([{
      name: '今日',
      value: 0
    }, {
      name: '昨日',
      value: 1
    }, {
      name: '前日',
      value: 2
    }, {
      name: '自定义日期',
      value: 3
    }]);
    const onClickTab = () => {
      if (active.value == 3) {
        show.value = true;
      } else {
        tabs.value[3].name = '自定义日期';
      }
      statParam.value.active = active.value;
      loadPieData();
      loadLineData();
    };
    const option = ref({
      tooltip: {
        trigger: 'item'
      },
      series: [{
        type: 'pie',
        radius: '50%',
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }]
    });
    const initChart = () => {
      let chartInstance = echarts.init(document.getElementById('chart' + active.value));
      chartInstance.setOption(option.value);
    };
    const lineChart = () => {
      let zxChartInstance = echarts.init(document.getElementById('charts' + active.value));
      zxChartInstance.setOption(zxOption.value);
    };
    async function loadPieData() {
      const res = await countStatApi(statParam.value);
      if (res.code == 200) {
        pieData.value = res.data ?? [];
        nextTick(() => {
          option.value.series[0].data = pieData.value;
          initChart();
        });
      } else {
        showNotify({
          type: 'danger',
          message: res.msg
        });
      }
    }
    const zxOption = ref({
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
      },
      yAxis: {
        type: 'value'
      },
      series: []
    });
    async function loadLineData() {
      const res = await lineStatApi(statParam.value);
      if (res.code == 200) {
        lineModel.value = res.data ?? {
          xaxisData: [],
          legendData: [],
          series: []
        };
        nextTick(() => {
          zxOption.value.xAxis.data = lineModel.value.xaxisData;
          //zxOption.value.legend.data = lineModel.value.legendData
          zxOption.value.series = lineModel.value.series;
          lineChart();
        });
      } else {
        showNotify({
          type: 'danger',
          message: res.msg
        });
      }
    }
    const onSearch = () => {
      debugger;
      loadPieData();
    };
    const onCancel = () => {
      statParam.value.name = '';
      loadPieData();
    };
    onMounted(() => {
      loadPieData();
      loadLineData();
    });
    return (_ctx, _cache) => {
      const _component_van_search = _resolveComponent("van-search");
      const _component_van_grid = _resolveComponent("van-grid");
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      const _component_van_calendar = _resolveComponent("van-calendar");
      const _component_tabbar = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_search, {
        background: "#1989fa",
        shape: "round",
        modelValue: _unref(statParam).name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(statParam).name = $event),
        onSearch: onSearch,
        onCancel: onCancel,
        placeholder: "请输入搜索关键词"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_tabs, {
        active: _unref(active),
        "onUpdate:active": _cache[1] || (_cache[1] = $event => _isRef(active) ? active.value = $event : null),
        onClickTab: onClickTab
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), item => {
          return _openBlock(), _createBlock(_component_van_tab, {
            title: item.name,
            key: item.value
          }, {
            default: _withCtx(() => [_createVNode(_component_van_grid, {
              clickable: "",
              "column-num": 1
            }, {
              default: _withCtx(() => [_unref(active) == item.value ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: 'chart' + _unref(active),
                class: "chart"
              }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024), _createVNode(_component_van_grid, {
              clickable: "",
              "column-num": 1
            }, {
              default: _withCtx(() => [_unref(active) == item.value ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: 'charts' + _unref(active),
                class: "chart"
              }, null, 8, _hoisted_3)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["title"]);
        }), 128))]),
        _: 1
      }, 8, ["active"]), _createVNode(_component_van_calendar, {
        show: _unref(show),
        "onUpdate:show": _cache[2] || (_cache[2] = $event => _isRef(show) ? show.value = $event : null),
        type: "range",
        "min-date": _unref(minDate),
        onConfirm: onConfirm
      }, null, 8, ["show", "min-date"])]), _createVNode(_component_tabbar, {
        active: 2
      })], 64);
    };
  }
});